import React from "react";
import { cn } from "@/lib/helpers/utils";

function QuranPageSkeleton() {
  return (
    <div className="relative mx-auto max-w-(--breakpoint-xl) px-2 py-10 md:flex md:flex-row md:py-10">
      <div className="sticky top-[121px] hidden h-[calc(100vh-121px)] w-[350px] xl:flex xl:shrink-0 xl:flex-col xl:justify-between">
        <div className="relative overflow-hidden">
          <div className="styled-scrollbar flex h-[calc(100vh-140px)] flex-col  pr-2 ">
            <div className="lrounded-lg border bg-card text-card-foreground shadow-xs left w-full overflow-hidden">
              <div className="p-6 pt-0">
                <div className="flex rounded-md bg-muted  animate-pulse overflow-hidden mt-5 h-10"></div>
                <div className="flex overflow-hidden mt-3 flex-row gap-4">
                  <div className="rounded-md animate-pulse w-4/5 item h-10   bg-muted"></div>
                  <div className="rounded-md animate-pulse w-1/5 item h-10  bg-muted"></div>
                </div>
                <div className="flex overflow-hidden mt-3 flex-row gap-4">
                  <div className="rounded-md animate-pulse w-4/5 item h-10">
                    {[...Array(28)].map((_, index) => {
                      return (
                        <div
                          key={index}
                          className={cn(
                            "rounded-md animate-pulse item h-10 w-full bg-muted",
                            index == 0 ? "" : " mt-3",
                          )}
                        ></div>
                      );
                    })}
                  </div>
                  <div className="rounded-md animate-pulse w-1/5 item h-screen  bg-muted"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="right w-2/3 m-auto">
        {[...Array(3)].map((_, index) => {
          return (
            <div
              key={index}
              className="rounded-lg border bg-card text-card-foreground shadow-xs left w-full overflow-hidden flex flex-col mb-3"
            >
              <div className="flex flex-row justify-center">
                <div
                  className={
                    "tanimate-pulse w-6 item h-6 bg-muted rounded-md mt-2"
                  }
                />
              </div>
              <div className="pt-7 md:pt-0 w-full">
                <div>
                  {[...Array(15)].map((_, index) => {
                    return (
                      <div
                        key={index}
                        className="rounded-md animate-pulse item h-12 w-full md:w-[45rem] bg-muted mt-3 m-auto"
                      ></div>
                    );
                  })}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default QuranPageSkeleton;
